import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateDigitalAgronomistCropPractices } from "services";

import { EXPORT_DIGITAL_AGRONOMIST_CROP_PRACTICES, UPDATE_DIGITAL_AGRONOMIST_CROP_PRACTICES } from "consts";

export const useUpdateDigitalAgronomistValues = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_DIGITAL_AGRONOMIST_CROP_PRACTICES],
    mutationFn: updateDigitalAgronomistCropPractices,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [EXPORT_DIGITAL_AGRONOMIST_CROP_PRACTICES] });
    },
  });
};
